var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestaurant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9601 5.73L18.5301 0.73C18.4719 0.520086 18.3465 0.335031 18.1731 0.203182C17.9998 0.0713329 17.7879 -3.87152e-05 17.5701 1.57551e-08H2.43009C1.98009 1.57551e-08 1.59009 0.3 1.47009 0.73L0.0400891 5.73C-0.139911 6.36 0.340089 7 1.00009 7H3.20009L2.00009 16H4.00009L4.67009 11H15.3401L16.0001 16H18.0001L16.8001 7H19.0001C19.6601 7 20.1401 6.36 19.9601 5.73ZM4.93009 9L5.20009 7H14.8001L15.0701 9H4.93009Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurant);
export default __webpack_public_path__ + "static/media/restaurant.bb491ebb.svg";
export { ForwardRef as ReactComponent };